import React from "react";
import NotFound from "./pages/notFound/NotFound";

export default function authorizePage(isAuthorized, jsxComponent) {
  if (isAuthorized) return jsxComponent;

  return <NotFound />;
}
